import { memo } from 'react'
import { Position } from 'reactflow'

import { FALLBACK_FLOW, MAIN_FLOW } from '../../constants'
import { useFlowBuilderSelector } from '../../reducer/hooks'
import { StartNodeProps } from '../../types'
import { HtIcon, Icon, Size, TextBodySmallBold } from '../base'
import { HandleType } from './handle-styles'
import { StyledHandle } from './node-components'
import { Code, StyledStartNode } from './node-styles'
import { FlowNote } from './note'

const StartNode = ({ data }: StartNodeProps) => {
  const currentFlowId = useFlowBuilderSelector(ctx => ctx.state.currentFlowId)

  return (
    <>
      <StyledStartNode $isSelected={false}>
        <Code>
          {data.errors.fieldErrors.length > 0 &&
            currentFlowId === MAIN_FLOW.id && (
              <HtIcon icon={Icon.EXCLAMATION_TRIANGLE} size={Size.MEDIUM} />
            )}
        </Code>
        <StyledHandle
          handleType={HandleType.INPUT}
          type='source'
          position={Position.Right}
          id={`start|${currentFlowId}_${data.id}`}
          isConnectable={currentFlowId !== FALLBACK_FLOW.id}
          isConnectableWithBotAction={false}
        />
        {currentFlowId === MAIN_FLOW.id && (
          <HtIcon size={Size.LARGE} icon={Icon.HOUSE} />
        )}
        <TextBodySmallBold>
          {currentFlowId === MAIN_FLOW.id ? 'Conversation start' : 'Flow start'}
        </TextBodySmallBold>
      </StyledStartNode>
      <FlowNote flowId={currentFlowId} />
    </>
  )
}

export default memo(StartNode)
